import CompanyModel from '@mm/state/model/CompanyModel';
import { Interpreter } from 'xstate';
import { SignUpFlowEvents } from './signUpMachineEventTypes';

export const enum SIGN_UP_FLOW_STATES_NAME {
  INIT = 'INIT',
  WELCOME = 'WELCOME',
  JOB_ROLE = 'JOB_ROLE',
  TEAM_SIZE = 'TEAM_SIZE',
  CLIENTS_CHARGE = 'CLIENTS_CHARGE',
  MONTHLY_AD_BUDGET = 'MONTHLY_AD_BUDGET',
  INDUSTRY = 'INDUSTRY',
  GOAL = 'GOAL',
  WEBSITE_TRAFFIC = 'WEBSITE_TRAFFIC',
  LEADS_LIST = 'LEADS_LIST',
  VIDEO = 'VIDEO',
  REDIRECT = 'REDIRECT',
  CONNECT_CHANNELS = 'CONNECT_CHANNELS',
}

export type SignUpFlowContext = {
  activeStep: number;
  company?: CompanyModel;
  stepOptions: {
    isOtherIndustrySelected: boolean;
  };
  isFBUser: boolean;
  isNewSignupFlow: boolean;
};

export type SignUpFlowStatesSchema = {
  states: {
    [SIGN_UP_FLOW_STATES_NAME.INIT]: {};
    [SIGN_UP_FLOW_STATES_NAME.WELCOME]: {};
    [SIGN_UP_FLOW_STATES_NAME.JOB_ROLE]: {};
    [SIGN_UP_FLOW_STATES_NAME.TEAM_SIZE]: {};
    [SIGN_UP_FLOW_STATES_NAME.CLIENTS_CHARGE]: {};
    [SIGN_UP_FLOW_STATES_NAME.MONTHLY_AD_BUDGET]: {};
    [SIGN_UP_FLOW_STATES_NAME.INDUSTRY]: {};
    [SIGN_UP_FLOW_STATES_NAME.GOAL]: {};
    [SIGN_UP_FLOW_STATES_NAME.LEADS_LIST]: {};
    [SIGN_UP_FLOW_STATES_NAME.WEBSITE_TRAFFIC]: {};
    [SIGN_UP_FLOW_STATES_NAME.VIDEO]: {};
    [SIGN_UP_FLOW_STATES_NAME.REDIRECT]: {};
    [SIGN_UP_FLOW_STATES_NAME.CONNECT_CHANNELS]: {};
  };
};

export type SignUpFlowMachineService = Interpreter<
  SignUpFlowContext,
  SignUpFlowStatesSchema,
  SignUpFlowEvents,
  {
    value: any;
    context: SignUpFlowContext;
  }
>;
